import React from "react";
import "./App.css";

function Services() {
  return (
    <div className="page-container content-page">
      <div className="container">
        <h1 className="page-title">Our Medical Services</h1>
        <p className="page-subtitle">
          Comprehensive, non-invasive, and surgical care for your senses.
        </p>

        <div className="services-grid large-grid">
          <div className="service-card">
            <div className="service-img">
              <img
                src="/ear.jpg"
                alt="Dr. Sunil Kumar Singh"
                className="profile-img portrait"
              />
            </div>
            <p>
              {" "}
              <br></br>
            </p>
            <h3>General ENT Checkup</h3>
            <p>
              Routine examination for infections, blockages, and pain
              management.
            </p>
          </div>
          <div className="service-card">
            <div className="service-img">
              <img
                src="/aid.png"
                alt="Dr. Sunil Kumar Singh"
                className="profile-img portrait"
              />
            </div>
            <p>
              {" "}
              <br></br>{" "}
            </p>
            <h3>Audiometry & Hearing Aids</h3>
            <p>Advanced hearing testing and digital hearing aid fitting.</p>
          </div>
          <div className="service-card">
            <div className="service-img">
              <img
                src="/ver.png"
                alt="Dr. Sunil Kumar Singh"
                className="profile-img portrait"
              />
              <p>
                {" "}
                <br></br>{" "}
              </p>
            </div>
            <h3>Vertigo Treatment</h3>
            <p>Diagnosis and management of dizziness and balance disorders.</p>
          </div>
          <div className="service-card">
            <div className="service-img">
              <img
                src="/all.png"
                alt="Dr. Sunil Kumar Singh"
                className="profile-img portrait"
              />
              <p>
                <br></br>
              </p>
            </div>
            <h3>Allergy Treatment</h3>
            <p>Comprehensive testing and immunotherapy for nasal allergies.</p>
          </div>
          <div className="service-card">
            <div className="service-img">
              <img
                src="/one.png"
                alt="Dr. Sunil Kumar Singh"
                className="profile-img portrait"
              />
              <p>
                <br></br>
              </p>
            </div>
            <h3>Ear pain / Ear ache </h3>
            <p>
              Ear Pain Treatment: Accurate diagnosis and targeted treatment to
              relieve ear pain caused by infections, inflammation, or
              pressure-related issues.
            </p>
          </div>
          <div className="service-card">
            <div className="service-img">
              <img
                src="/two.png"
                alt="Dr. Sunil Kumar Singh"
                className="profile-img portrait"
              />
              <p>
                <br></br>
              </p>
            </div>
            <h3>Tinnitus / ringing in ear </h3>
            <p>
              Comprehensive evaluation and personalized treatment to reduce
              ringing, buzzing, or hissing sounds and improve quality of life.
            </p>
          </div>
          <div className="service-card">
            <div className="service-img">
              <img
                src="/three.png"
                alt="Dr. Sunil Kumar Singh"
                className="profile-img portrait"
              />
              <p>
                <br></br>
              </p>
            </div>
            <h3>Hard of Hearing / Decreased Hearing </h3>
            <p>
              Detailed hearing assessment and personalized treatment to identify
              causes of hearing loss and restore optimal hearing function.
            </p>
          </div>
          <div className="service-card">
            <div className="service-img">
              <img
                src="/four.png"
                alt="Dr. Sunil Kumar Singh"
                className="profile-img portrait"
              />
              <p>
                <br></br>
              </p>
            </div>
            <h3>Nasal Blockage </h3>
            <p>
              Accurate diagnosis and personalized medical or surgical care to
              relieve nasal congestion and restore clear, comfortable breathing.
            </p>
          </div>
          <div className="service-card">
            <div className="service-img">
              <img
                src="/five.png"
                alt="Dr. Sunil Kumar Singh"
                className="profile-img portrait"
              />
              <p>
                <br></br>
              </p>
            </div>
            <h3>Nasal Discharge </h3>
            <p>
              Thorough evaluation and targeted medical care to identify the
              cause of nasal discharge and provide effective, lasting relief.
            </p>
          </div>
          <div className="service-card">
            <div className="service-img">
              <img
                src="/six.png"
                alt="Dr. Sunil Kumar Singh"
                className="profile-img portrait"
              />
              <p>
                <br></br>
              </p>
            </div>
            <h3>Facial Pain </h3>
            <p>
              Precise diagnosis and individualized treatment to identify the
              underlying cause of facial pain and provide effective, long-term
              relief.
            </p>
          </div>
          <div className="service-card">
            <div className="service-img">
              <img
                src="/seven.png"
                alt="Dr. Sunil Kumar Singh"
                className="profile-img portrait"
              />
              <p>
                <br></br>
              </p>
            </div>
            <h3>Headache </h3>
            <p>
              Comprehensive evaluation and personalized care to identify the
              cause of headaches and provide safe, effective, long-term relief.
            </p>
          </div>
          <div className="service-card">
            <div className="service-img">
              <img
                src="/eight.png"
                alt="Dr. Sunil Kumar Singh"
                className="profile-img portrait"
              />
              <p>
                <br></br>
              </p>
            </div>
            <h3>Sneezing </h3>
            <p>
              Accurate evaluation and personalized treatment to identify
              triggers such as allergies or infections and provide effective,
              lasting relief.
            </p>
          </div>
          <div className="service-card">
            <div className="service-img">
              <img
                src="/nine.png"
                alt="Dr. Sunil Kumar Singh"
                className="profile-img portrait"
              />
              <p>
                <br></br>
              </p>
            </div>
            <h3>Throat pain </h3>
            <p>
              Accurate diagnosis and personalized treatment to relieve throat
              pain caused by infections, inflammation, acid reflux, or voice
              strain.
            </p>
          </div>
          <div className="service-card">
            <div className="service-img">
              <img
                src="/ten.png"
                alt="Dr. Sunil Kumar Singh"
                className="profile-img portrait"
              />
              <p>
                <br></br>
              </p>
            </div>
            <h3>Sore throat </h3>
            <p>
              Accurate evaluation and personalized treatment to relieve throat
              irritation and pain caused by infections, allergies, acid reflux,
              or voice strain.
            </p>
          </div>
          <div className="service-card">
            <div className="service-img">
              <img
                src="/11.png"
                alt="Dr. Sunil Kumar Singh"
                className="profile-img portrait"
              />
              <p>
                <br></br>
              </p>
            </div>
            <h3>Difficulty in Swallowing </h3>
            <p>
              Accurate evaluation and personalized treatment to relieve throat
              irritation and pain caused by infections, allergies, acid reflux,
              or voice strain.
            </p>
          </div>
          <div className="service-card">
            <div className="service-img">
              <img
                src="/12.png"
                alt="Dr. Sunil Kumar Singh"
                className="profile-img portrait"
              />
              <p>
                <br></br>
              </p>
            </div>
            <h3>Voice Change </h3>
            <p>
              Accurate evaluation and personalized treatment to identify causes
              such as voice strain, infections, acid reflux, or vocal cord
              disorders and restore a clear, healthy voice.
            </p>
          </div>
          <div className="service-card">
            <div className="service-img">
              <img
                src="/13.png"
                alt="Dr. Sunil Kumar Singh"
                className="profile-img portrait"
              />
              <p>
                <br></br>
              </p>
            </div>
            <h3>Neck pain </h3>
            <p>
              Accurate evaluation and personalized treatment to identify causes
              such as muscle strain, nerve compression, cervical spine issues,
              or referred ENT conditions and provide effective, long-term
              relief.
            </p>
          </div>
          <div className="service-card">
            <div className="service-img">
              <img
                src="/14.png"
                alt="Dr. Sunil Kumar Singh"
                className="profile-img portrait"
              />
              <p>
                <br></br>
              </p>
            </div>
            <h3>Neck swelling </h3>
            <p>
              Accurate evaluation and personalized treatment to identify causes
              such as infections, enlarged lymph nodes, thyroid disorders, or
              other neck conditions and provide timely, effective care.
            </p>
          </div>
          <div className="service-card">
            <div className="service-img">
              <img
                src="/15.png"
                alt="Dr. Sunil Kumar Singh"
                className="profile-img portrait"
              />
              <p>
                <br></br>
              </p>
            </div>
            <h3>Ear Lobe repair </h3>
            <p>
              A safe, minor surgical procedure to correct torn, stretched, or
              split earlobes, restoring their natural shape and appearance with
              minimal downtime.
            </p>
          </div>
          <div className="service-card">
            <div className="service-img">
              <img
                src="/16.png"
                alt="Dr. Sunil Kumar Singh"
                className="profile-img portrait"
              />
              <p>
                <br></br>
              </p>
            </div>
            <h3> Myringoplasty </h3>
            <p>
              A precise surgical procedure to repair a perforated eardrum,
              improving hearing, preventing recurrent ear infections, and
              restoring ear health.
            </p>
          </div>
          <div className="service-card">
            <div className="service-img">
              <img
                src="/16.png"
                alt="Dr. Sunil Kumar Singh"
                className="profile-img portrait"
              />
              <p>
                <br></br>
              </p>
            </div>
            <h3> Eardrum Surgery </h3>
            <p>
              A precise surgical procedure to repair a perforated or damaged
              eardrum, restore hearing, prevent recurrent ear infections, and
              improve overall ear health.
            </p>
          </div>
          <div className="service-card">
            <div className="service-img">
              <img
                src="/17.png"
                alt="Dr. Sunil Kumar Singh"
                className="profile-img portrait"
              />
              <p>
                <br></br>
              </p>
            </div>
            <h3> Tympanoplasty </h3>
            <p>
              A surgical procedure to reconstruct a perforated or damaged
              eardrum and, if needed, the small bones of the middle ear,
              restoring hearing, preventing recurrent infections, and improving
              overall ear health.
            </p>
          </div>
          <div className="service-card">
            <div className="service-img">
              <img
                src="/18.png"
                alt="Dr. Sunil Kumar Singh"
                className="profile-img portrait"
              />
              <p>
                <br></br>
              </p>
            </div>
            <h3> Mastoidectomy </h3>
            <p>
              A surgical procedure to remove infected or diseased mastoid air
              cells in the skull behind the ear, typically performed to treat
              chronic ear infections or cholesteatoma, preventing complications
              and preserving hearing.
            </p>
          </div>
          <div className="service-card">
            <div className="service-img">
              <img
                src="/19.png"
                alt="Dr. Sunil Kumar Singh"
                className="profile-img portrait"
              />
              <p>
                <br></br>
              </p>
            </div>
            <h3> Septoplasty </h3>
            <p>
              A surgical procedure to correct a deviated nasal septum, improving
              nasal airflow, relieving chronic congestion, and reducing related
              symptoms such as snoring or recurrent sinus infections.
            </p>
          </div>
          <div className="service-card">
            <div className="service-img">
              <img
                src="/19.png"
                alt="Dr. Sunil Kumar Singh"
                className="profile-img portrait"
              />
              <p>
                <br></br>
              </p>
            </div>
            <h3> Septoplasty </h3>
            <p>
              A surgical procedure to correct a deviated nasal septum, improving
              nasal airflow, relieving chronic congestion, and reducing related
              symptoms such as snoring or recurrent sinus infections.
            </p>
          </div>
          <div className="service-card">
            <div className="service-img">
              <img
                src="/20.png"
                alt="Dr. Sunil Kumar Singh"
                className="profile-img portrait"
              />
              <p>
                <br></br>
              </p>
            </div>
            <h3> Smr </h3>
            <p>
              A surgical procedure to remove or reshape parts of the nasal
              septum beneath the mucosal lining, improving nasal airflow,
              relieving chronic nasal obstruction, and often performed when
              septoplasty alone is insufficient.
            </p>
          </div>
          <div className="service-card">
            <div className="service-img">
              <img
                src="/20.png"
                alt="Dr. Sunil Kumar Singh"
                className="profile-img portrait"
              />
              <p>
                <br></br>
              </p>
            </div>
            <h3> FESS </h3>
            <p>
              A minimally invasive surgical procedure to restore normal drainage
              of the sinuses by removing blockages, treating chronic sinusitis,
              nasal polyps, or other sinus conditions, and improving breathing
              and sinus health
            </p>
          </div>
          <div className="service-card">
            <div className="service-img">
              <img
                src="/21.png"
                alt="Dr. Sunil Kumar Singh"
                className="profile-img portrait"
              />
              <p>
                <br></br>
              </p>
            </div>
            <h3> Adenoidectomy </h3>
            <p>
              A surgical procedure to remove enlarged or infected adenoids,
              improving nasal breathing, reducing recurrent ear infections, and
              alleviating sleep-related breathing problems.
            </p>
          </div>
          <div className="service-card">
            <div className="service-img">
              <img
                src="/22.png"
                alt="Dr. Sunil Kumar Singh"
                className="profile-img portrait"
              />
              <p>
                <br></br>
              </p>
            </div>
            <h3> Tonsillectomy </h3>
            <p>
              A surgical procedure to remove the tonsils, typically performed to
              treat recurrent throat infections, obstructive sleep issues, or
              chronic tonsillitis, improving overall throat health and
              breathing.
            </p>
          </div>
          <div className="service-card">
            <div className="service-img">
              <img
                src="/23.png"
                alt="Dr. Sunil Kumar Singh"
                className="profile-img portrait"
              />
              <p>
                <br></br>
              </p>
            </div>
            <h3> UPPP </h3>
            <p>
              A surgical procedure to remove excess tissue from the throat,
              including the uvula and part of the soft palate, to improve
              airflow, reduce snoring, and treat obstructive sleep apnea.
            </p>
          </div>
          <div className="service-card">
            <div className="service-img">
              <img
                src="/24.png"
                alt="Dr. Sunil Kumar Singh"
                className="profile-img portrait"
              />
              <p>
                <br></br>
              </p>
            </div>
            <h3> MLS Surgery </h3>
            <p>
              A precise, minimally invasive surgical procedure performed on the
              vocal cords or larynx using a microscope, typically to remove
              nodules, polyps, cysts, or lesions, restore normal voice function,
              and improve breathing if needed.
            </p>
          </div>
          <div className="service-card">
            <div className="service-img">
              <img
                src="/25.png"
                alt="Dr. Sunil Kumar Singh"
                className="profile-img portrait"
              />
              <p>
                <br></br>
              </p>
            </div>
            <h3> Direct and Video Laryngoscopy </h3>
            <p>
              A diagnostic procedure using a direct or video-assisted scope to
              examine the larynx and vocal cords, identify abnormalities, and
              guide treatment for voice, breathing, or throat disorders.
            </p>
          </div>
          <div className="service-card">
            <div className="service-img">
              <img
                src="/26.png"
                alt="Dr. Sunil Kumar Singh"
                className="profile-img portrait"
              />
              <p>
                <br></br>
              </p>
            </div>
            <h3> Nasal Endoscopy </h3>
            <p>
              A minimally invasive diagnostic procedure using a thin, flexible
              endoscope to examine the nasal passages and sinuses, helping
              detect infections, polyps, structural abnormalities, or other ENT
              conditions for accurate diagnosis and treatment planning.
            </p>
          </div>
          <div className="service-card">
            <div className="service-img">
              <img
                src="/27.png"
                alt="Dr. Sunil Kumar Singh"
                className="profile-img portrait"
              />
              <p>
                <br></br>
              </p>
            </div>
            <h3> Hemi Thyroidectomy </h3>
            <p>
              A surgical procedure to remove one lobe of the thyroid gland,
              typically performed to treat nodules, goiter, or thyroid cancer,
              preserving the remaining thyroid tissue and maintaining hormone
              balance.
            </p>
          </div>
          <div className="service-card">
            <div className="service-img">
              <img
                src="/28.png"
                alt="Dr. Sunil Kumar Singh"
                className="profile-img portrait"
              />
              <p>
                <br></br>
              </p>
            </div>
            <h3>Parotidectomy </h3>
            <p>
              A surgical procedure to remove part or all of the parotid gland,
              typically performed to treat tumors, chronic infections, or
              stones, while preserving facial nerve function and maintaining
              gland function.
            </p>
          </div>
          <div className="service-card">
            <div className="service-img">
              <img
                src="/29.png"
                alt="Dr. Sunil Kumar Singh"
                className="profile-img portrait"
              />
              <p>
                <br></br>
              </p>
            </div>
            <h3>Submandibular Gland Treatment </h3>
            <p>
              A surgical procedure to treat disorders of the submandibular
              gland, such as stones, infections, or tumors, aiming to restore
              normal gland function and relieve pain or swelling in the jaw and
              neck region.
            </p>
          </div>
          <div className="service-card">
            <div className="service-img">
              <img
                src="/30.png"
                alt="Dr. Sunil Kumar Singh"
                className="profile-img portrait"
              />
              <p>
                <br></br>
              </p>
            </div>
            <h3>Ear piersing </h3>
            <p>
              A safe, minor procedure to create a hole in the earlobe or
              cartilage for wearing earrings, performed under hygienic
              conditions with minimal discomfort and care instructions for
              proper healing.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Services;
